import { createStyles, makeStyles } from '@material-ui/core/styles';

import { variables } from '@styles';

/**
 * ContentModuleCard component styles
 * @returns {Function}
 */

const transition = 'all 0.3s';

export const useStyles = makeStyles((theme) =>
  createStyles({
    contentModuleCard: {
      backgroundColor: variables.colorV2.contentModuleCard.default.background.default,
      border: `1px solid ${variables.colorV2.contentModuleCard.default.border.default}`, //`${variables.borderWidth.md} solid ${variables.color.primary.lightGray}`,
      borderRadius: '.8rem', // variables.borderRadius.sm,
      position: 'relative',
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start', // 'flex-end',
      transition,

      // '&:after': {
      //   content: '""',
      //   position: 'absolute',
      //   height: `calc(100% + ${variables.borderWidth.xl})`,
      //   width: `calc(100% + ${variables.borderWidth.xl})`,
      //   left: `-${variables.borderWidth.lg}`,
      //   top: `-${variables.borderWidth.lg}`,
      //   border: `1px solid ${variables.colorV2.contentModuleCard.default.border.hover}`, // `${variables.borderWidth.lg} solid ${variables.color.primary.lightPurple}`,
      //   borderRadius: '.8rem', // variables.borderRadius.sm,
      //   opacity: 0,
      //   transition,
      //   zIndex: -1,
      // },

      '&:hover': {
        borderColor: variables.colorV2.contentModuleCard.default.border.hover,

        '&:after': {
          opacity: 1,
        },
      },

      '&.active': {
        '&:after': {
          height: `calc(100% + 0.3rem * 2)`,
          width: `calc(100% + 0.3rem * 2)`,
          left: `-0.3rem`,
          top: `-0.3rem`,
          border: `0.3rem solid ${variables.color.primary.mainPurple}`,
          opacity: 1,
        },
      },
    },

    contentImage: {
      backgroundColor: variables.colorV2.contentModuleCard.default.background.default,
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      borderBottom: `${variables.borderWidth.md} solid ${variables.color.primary.lightGray}`,
      borderRadius: '.8rem',
      height: '16.3rem',
      position: 'relative',
    },

    coverImageWrapper: {
      backgroundColor: variables.colorV2.contentModuleCard.default.background.default,
      borderBottom: `${variables.borderWidth.md} solid ${variables.color.primary.lightGray}`,
      borderRadius: '.8rem',
      height: '16.3rem',
      overflow: 'hidden',
      position: 'relative',
    },

    purgeBtn: {
      color: '#ccc',
      padding: 0,
      '&:hover': {
        '& SVG PATH': {
          stroke: variables.colorV2.button.iconAlternate.stroke.hover,
        },
      },
    },

    coverImage: {
      width: '100%',
      height: 'auto',
      position: 'absolute',
    },

    content: {
      padding: theme.spacing(1, 2, 2, 2),
    },

    name: {
      color: variables.colorV2.contentModuleCard.default.text.default,
      fontWeight: 600,
      marginBottom: theme.spacing(0.5),
      maxWidth: '80%',
      paddingRight: '0.5rem',
    },

    ctir: {
      lineHeight: '1.8rem',
      minWidth: '6rem',
      textAlign: 'right',
    },

    index: {
      '&&': {
        color: variables.colorV2.contentModuleCard.default.text.default,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        background: variables.colorV2.contentModuleCard.default.background.id,
        borderRadius: '2px',
        width: 'fit-content',
        padding: '2px 5px',
        fontWeight: '700',
        fontSize: '9px',
        cursor: 'pointer',
      },
    },

    contentValue: {
      fontWeight: 500,
      color: variables.colorV2.contentModuleCard.default.text.default,
    },

    deploymentName: {
      width: '40%',
      textAlign: 'right',
      display: 'flex',
      gap: '10px',
      justifyContent: 'flex-end',
    },

    moduleRow: {
      display: 'flex',
      alignItems: 'top',
      justifyContent: 'space-between',
    },

    moduleRow2: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },

    infoGroup: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '7px',
    },
  }),
);
